"use client";
import type * as React from "react";

export interface HeadTitleProps {
	pageTitle: string;
}

export function HeadTitle(_props: HeadTitleProps): React.ReactElement | null {
	// In Next.js App Router, title is handled by metadata export in page or layout.
	// This component will just return null.
	return null;
}
